var _style, _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBeefLiver({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 212.6 212.6",
    style: {
      enableBackground: "new 0 0 212.6 212.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#F8EEE1;}\n\t.st1{fill:#C05364;}\n\t.st2{fill:#D37283;}\n\t.st3{fill:#90404B;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M103.42,184.22c42.69,0,77.3-34.29,77.3-76.6c0-42.3-34.61-76.6-77.3-76.6s-77.3,34.29-77.3,76.6 C26.12,149.93,60.73,184.22,103.42,184.22"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M129.57,86.85c-6.47,0-10.26,0.73-13.61,1.38c-5.9,1.14-9.79,1.89-22.07-2.67 c-7.04-2.61-13.09-4.62-18.21-4.62c-4.05,0-7.52,1.26-10.44,4.47c-5.95,6.55-2.2,13.63,1.77,21.12c3.7,6.98,7.52,14.2,3.58,21.35 c-1.99,3.6-2.03,7.36-0.13,10.58c2,3.39,5.9,5.59,9.92,5.59c8.58,0,15.63-6.4,21.98-13.32c3.64-3.97,7.64-7.75,11.89-11.21 c2.2-1.8,4.45-4.19,5.85-7.09c0.17,0.01,0.32,0.05,0.49,0.05c1.08,0,2.03-0.21,2.87-0.55c2,0.39,5.14-0.71,8.46-1.91 c3.22-1.17,6.56-2.38,9.82-2.63c6.76-0.54,10.04-4.09,10.04-10.85C151.78,90.1,144.3,86.85,129.57,86.85z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M69.12,87.29c-2.22,1.63-3.29,3.95-3.03,6.51c0.07,0.66,0.63,1.16,1.28,1.16c0.04,0,0.09,0,0.13-0.01 c0.71-0.07,1.22-0.71,1.15-1.41c-0.17-1.67,0.5-3.07,1.99-4.17c0.57-0.42,0.7-1.23,0.27-1.8C70.5,86.99,69.69,86.87,69.12,87.29z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M75.04,84c-0.05,0.01-0.47,0.05-1.11,0.22c-0.69,0.18-1.11,0.88-0.93,1.57c0.15,0.58,0.67,0.97,1.25,0.97 c0.11,0,0.21-0.01,0.32-0.04c0.45-0.12,0.74-0.15,0.75-0.15c0.71-0.08,1.22-0.71,1.14-1.42C76.39,84.44,75.75,83.92,75.04,84z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M107.26,116.18c-0.31,0.21-0.64,0.42-0.98,0.62c-0.61,0.37-0.8,1.16-0.43,1.77c0.24,0.4,0.67,0.62,1.1,0.62 c0.23,0,0.46-0.06,0.67-0.19c0.38-0.23,0.73-0.46,1.08-0.69c0.59-0.4,0.75-1.2,0.35-1.79 C108.65,115.94,107.85,115.78,107.26,116.18z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M114.7,105.2c-0.7,0.1-1.18,0.76-1.09,1.46c0.02,0.13,0.39,3.2-3.1,6.83c-0.49,0.51-0.48,1.33,0.04,1.82 c0.25,0.24,0.57,0.36,0.89,0.36c0.34,0,0.68-0.13,0.93-0.4c4.43-4.62,3.81-8.83,3.78-9.01C116.05,105.57,115.4,105.1,114.7,105.2z "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M121.61,112.58c-0.76,0-1.03-0.1-1.66,0.1c-0.17-1.73,0.4-5.14,0.79-7.03c0.53-2.57,1.07-5.22-0.11-6.19 c-0.64-0.53-0.74-1.47-0.21-2.11c0.53-0.64,1.47-0.74,2.11-0.21c2.58,2.11,1.82,5.83,1.15,9.11c-0.34,1.67,0.17,4.45,0.29,5.73 c-0.85,0.27-1.39,0.51-2.21,0.59C121.71,112.57,121.66,112.58,121.61,112.58z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBeefLiver);
export default __webpack_public_path__ + "static/media/Beef_liver.94e076a4fdbda296d1936a70f097d6c9.svg";
export { ForwardRef as ReactComponent };